import { type Database, DatabaseFieldType } from '@databases/types/database';

export const hasUserEditedAiSummaryCells = ({
  database,
  fieldId
}: {
  database: Pick<Database, 'entries' | 'entriesById'>;
  fieldId: string;
}) =>
  database.entries.some((entryId) => {
    const value = database.entriesById[entryId]?.values[fieldId];

    return (
      value?.type === DatabaseFieldType.AI_SUMMARY &&
      value.value.metadata?.lastUpdatedBy === 'user'
    );
  });
